import {
    AddressSiteText,
    CustomeSiteText,
    InstalledBaseImg,
    SiteSelected,
} from "./InstalledBaseImage.styles";
import InstalledBaseHeader from "../../../../assets/images/Installed-base.jpg";
import { useReduxState } from "../../../../../explorer/redux/hooks";
import { Site } from "../../../../../explorer/types/SpareParts";
import { reduxStoreConfig } from "../../../../configuration/reduxStoreConfig";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import { Box, Typography } from "@mui/material";
import { useClasses } from "../InstalledBaseImage/InstalledBaseImage.styles";
import useCurrentSite from "../../../../hook/useCurrentSite";

const InstalledBaseImage = () => {
    const [siteSelected, setSiteSelected] = useCurrentSite();

    const { t } = useTranslation();
    const classes = useClasses();

    return (
        <InstalledBaseImg
            sx={{ backgroundImage: `url(${InstalledBaseHeader})` }}
        >
            <SiteSelected>
                <Box sx={{ textAlign: "start", marginLeft: 5 }}>
                    {/*
            <CustomeSiteText>
              {" "}
              {t("common.homepage.selectedcustomersite")}
            </CustomeSiteText>
          */}
                    <Typography sx={classes.text} variant="h6" component={"p"}>
                        <AddressSiteText>{siteSelected.customerSiteCode}</AddressSiteText>
                        {siteSelected.customerSiteName} <br />
                        <AddressSiteText>
                            {siteSelected.address} {siteSelected.address && "- "}
                            {siteSelected.city} {siteSelected.zipCode} (
                            {siteSelected.country})
                        </AddressSiteText>
                    </Typography>
                </Box>
            </SiteSelected>
        </InstalledBaseImg>
    );
};

export default InstalledBaseImage;
